import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { dannyKanell } from "@/lib/celebrity-results/danny-kanell";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Danny Kanell Hair Transplant Results | RESTORE® Hair";
const DESC = "See former NFL quarterback Danny Kanell's RESTORE® No-Shave FUE™ hair transplant results, before & after photos and his hair restoration story.";
const POSTER = "https://assets.restorehair.com/wp/2024/09/Restore_DannyKanell_After_045-1-1.webp";

export const Route = createFileRoute("/results/danny-kanell")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/danny-kanell/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/danny-kanell/" },
    ],
  }),
  component: () => <CelebrityResultPage data={dannyKanell} />,
});
